define.alias("shared/utils/formatters/create-formatted-industry-hashtags", "preview-grid/utils/formatters/create-formatted-industry-hashtags");